<template>
  <div class="input-wrapper url-input-wrapper">
    <input type="text" class="input" v-model="internValue" :required="required" ref="urlInput"
           v-on:keyup="onKeyUp"
           v-bind:class="(internValue === prefix) ? 'prefix-empty' : ''"
           @input="onChange"
           spellcheck="false"/>
    <label class="label"
           v-bind:class="(value !== '' && value !== null && value !== undefined) || prefix ? 'filled-input' :  '' ">
      {{ placeHolder }}{{ required ? '*' : '' }}</label>

  </div>
</template>

<script>
import {deepCopy, isDefined} from "@/utils";

export default {
  name: "CustomInputUrl",
  props: {
    value: {
      required: true
    },
    placeHolder: {
      required: false,
      type: String
    },
    prefix: {
      required: false,
      type: String
    },
    required: {
      required: false,
      type: Boolean
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal, oldVal) {
        if (isDefined(this.prefix)) {
          if (isDefined(newVal) && newVal.startsWith(this.prefix)) {
            this.internValue = newVal;
          } else {
            this.internValue = `${this.prefix}`
          }
        } else {
          this.internValue = newVal;
        }
      }
    }
  },
  data() {
    return {
      internValue: undefined
    }
  },
  methods: {
    checkForValidUrl() {
      const input = this.$refs.urlInput;
      if (isDefined(this.internValue) && this.internValue !== '') {
        const isValid = this.validateInternUrl();
        if (!isValid) {
          input.setCustomValidity(this.$t('invalid-url').toString());
        } else {
          input.setCustomValidity('');
          input.reportValidity();
        }
      } else {
        input.setCustomValidity('');
        input.reportValidity();
      }
    },
    onKeyUp() {
      this.checkForValidUrl();
      if (this.internValue === this.prefix) {
        this.$emit('update:value', undefined)
      } else {
        this.$emit('update:value', this.internValue)
      }
    },
    onChange(inputEvent) {
      if (isDefined(inputEvent) && isDefined(inputEvent.data) && inputEvent.inputType === 'insertReplacementText') {
        this.internValue = inputEvent.data;
      }
      if (isDefined(inputEvent) && isDefined(inputEvent.data) && inputEvent.inputType === 'insertFromPaste') {
        if (isDefined(this.prefix) && inputEvent.data.startsWith(this.prefix)) {
          this.internValue = inputEvent.data;
        }
        this.internValue = this.internValue.trim();
      }
      this.checkForValidUrl();
      if (this.internValue === this.prefix) {
        this.$emit('update:value', undefined)
      } else {
        this.$emit('update:value', this.internValue)
      }
    },
    validateInternUrl() {
      let value = deepCopy(this.internValue);
      try {
        const url = new URL(value);
      } catch (_) {
        if (value.startsWith('@') && value.length === 1) {
          return false;
        }
        if (value.startsWith('http://') || value.startsWith('https://')) {
          return false;
        }
        if (!value.includes('/')) {
          return true;
        }
        return false;
      }
      return true;
    }

  }
}
</script>
